import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Http, RequestOptions, HttpModule } from '@angular/http';
import { AuthHttp, AuthConfig } from 'angular2-jwt';

import { AppRoutingModule } from './app.routing';
import { CalendarModule } from 'angular-calendar';
import { CalendarWeekHoursViewModule } from 'angular-calendar-week-hours-view';

// Components
import { AppComponent } from './app.component';

import {
  AppCalendarComponent,
  AppTopBarComponent,
  AppSideBarComponent,
  AppUsersComponent,
  AppAddBarComponent,
  RemoveDialogComponent
} from './components';

import {
  LoginViewComponent,
  DashboardViewComponent
} from './views';

// Directives

import { 
  SideBarDirective, 
  AddBarDirective
} from './directives';

// Service
import {
  AuthService,
  AuthGuardService,
  ReservationService,
  EventsService,
  UserService
} from './services';

// Modules
import { 
  MatButtonModule, 
  MatCheckboxModule,
  MatFormFieldModule,
  MatInputModule,
  MatIconModule,
  MatMenuModule,
  MatDatepickerModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatSortModule,
  MatTableModule,
  MatDialogModule
} from '@angular/material';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {
  return new AuthHttp(new AuthConfig({
    tokenName: 'token',
    tokenGetter: (() => localStorage.getItem('token')),
    globalHeaders: [{ 'Content-Type': 'application/json' }],
  }), http, options);
}

@NgModule({
  declarations: [
    AppComponent,
    AppCalendarComponent,
    LoginViewComponent,
    DashboardViewComponent,
    AppTopBarComponent,
    AppSideBarComponent,
    AppUsersComponent,
    AppAddBarComponent,
    RemoveDialogComponent,
    SideBarDirective,
    AddBarDirective,    
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NoopAnimationsModule,
    MatButtonModule, 
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatMenuModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatTableModule,
    MatSortModule,
    MatDialogModule,
    CommonModule,
    FormsModule,
    HttpModule,
    CalendarModule.forRoot(),
    CalendarWeekHoursViewModule
  ],
  entryComponents: [
    RemoveDialogComponent
  ],
  providers: [
    AuthService,
    AuthGuardService,
    ReservationService,
    EventsService,
    UserService,
    {
      provide: AuthHttp,
      useFactory: authHttpServiceFactory,
      deps: [Http, RequestOptions]
    }
  ],
  bootstrap: [AppComponent]  
})
export class AppModule { }



// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/app.module.ts